import * as React from 'react';
import { SVGProps } from 'react';

const IconFunnelSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M22 2H2v2.24a2 2 0 0 0 .505 1.328l6.99 7.864A2 2 0 0 1 10 14.76V23l4-2v-6.24a2 2 0 0 1 .505-1.328l6.99-7.864A2 2 0 0 0 22 4.24V2z" />
  </svg>
);
export default IconFunnelSizeM;
